<template>
  <!-- 5-3 教育机构信息查看页面 -->
  <div class="main-box">
    <div class="main-box-all-css">
      <!-- 主要内容部分 -->
      <div class="main-box-css">
        <!-- 左边表单部分 -->
        <div class="left-box">
          <!-- 第一行 -->
          <div class="one-line">
            <div class="avatar">
              <img
                :src="address"
                alt=""
                @error="
                  e => {
                    e.target.src = require('@/assets/defaultImg.png');
                  }
                "
              />
            </div>
            <div class="institution-name">
              <div class="institution-box">
                <div class="institution-title">{{ $t("certified") }}</div>
                <span>{{ $t("institutionName") }}</span>
                <p class="institution-main">{{ institutionName }}</p>
              </div>
            </div>
          </div>
          <!-- 第二行 -->
          <div class="two-line">
            <div class="small-input-box">
              <span>{{ $t("postCode") }}</span>
              <p class="small-box-title">{{ postCode }}</p>
            </div>
            <div class="big-input-box">
              <span>{{ $t("location") }}</span>
              <p class="small-box-title">{{ area }}</p>
            </div>
          </div>
          <!-- 第三行 -->
          <div class="two-line">
            <div class="small-input-box">
              <span>{{ $t("institutionalAttributes") }}</span>
              <!--              <p class="small-box-title">{{ agencyAttribute }}</p>-->
              <p class="small-box-title" v-if="language === 'CN'">
                {{ schooltableData.attributes_dictText }}
              </p>
              <p class="small-box-title" v-if="language === 'JP'">
                {{ schooltableData.jpattributes_dictText }}
              </p>
            </div>
            <div class="big-input-box">
              <span>{{ $t("hpOrSns") }}</span>
              <p class="small-box-title">{{ hPorSNS }}</p>
            </div>
          </div>
          <!-- 第四行 -->
          <div class="two-line">
            <div class="small-input-box">
              <span>{{ $t("representativeName") }}</span>
              <p class="small-box-title">{{ representativeName }}</p>
            </div>
            <div class="big-input-box">
              <span>{{ $t("institutionalNumber") }}</span>
              <p class="small-box-title">{{ phoneNumber }}</p>
            </div>
          </div>
          <!-- 第五行 -->
          <div class="two-line">
            <div class="small-input-box">
              <span>{{ $t("numberOfEmployees") }}</span>
              <!--              <p class="small-box-title">{{ numberEmployees }}</p>-->
              <p class="small-box-title" v-if="language === 'CN'">
                {{ schooltableData.teacherNumber_dictText }}
              </p>
              <p class="small-box-title" v-if="language === 'JP'">
                {{ schooltableData.jpteacherNumber_dictText }}
              </p>
            </div>
            <div class="big-input-box">
              <span>{{ $t("studentNumber") }}</span>
              <!--              <p class="small-box-title">{{ studentNumber }}</p>-->
              <p class="small-box-title" v-if="language === 'CN'">
                {{ schooltableData.studentNumber_dictText }}
              </p>
              <p class="small-box-title" v-if="language === 'JP'">
                {{ schooltableData.jpstudentNumber_dictText }}
              </p>
            </div>
          </div>
          <!-- 第六行 -->
          <div class="textarea-line">
            <div class="textarea-line-box">
              <span>{{ $t("businessContent") }}</span>
              <p class="textarea-css-main">{{ textData }}</p>
            </div>
          </div>
        </div>
        <!-- 右边表格部分 -->
        <div class="right-box">
          <el-table :data="tableData" style="width: 100%" height="500px">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              prop="name"
              label="学生氏名"
              width="120"
              :show-overflow-tooltip="true"
            >
              <template slot="header">
                <p>{{ $t("studentName") }}</p>
                <!-- <el-input
                  v-model="tableSearch1"
                  size="mini"
                  placeholder="Search"
                /> -->
              </template>
            </el-table-column>
            <el-table-column
              label="性別"
              width="80"
              :show-overflow-tooltip="true"
            >
              <template slot="header" slot-scope="scope">
                <p>{{ $t("sex") }}</p>
                <!-- <el-input
                  v-model="tableSearch2"
                  size="mini"
                  placeholder="Search"
                /> -->
              </template>
              <template slot-scope="scope">
                <span v-if="language === 'CN'">
                  {{ scope.row.sex_dictText }}
                </span>
                <span v-else>
                  {{ scope.row.jpsex_dictText }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="birth"
              label="生年月日"
              width="120"
              :show-overflow-tooltip="true"
            >
              <template slot="header">
                <p>{{ $t("birth") }}</p>
                <!-- <el-input
                  v-model="tableSearch3"
                  size="mini"
                  placeholder="Search"
                /> -->
              </template>
              <template slot-scope="scope">
                <p>{{ scope.row.birth.split(" ")[0] }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="education"
              label="学歴"
              :show-overflow-tooltip="true"
            >
              <template slot="header">
                <p>{{ $t("education") }}</p>
              </template>
              <template slot-scope="scope">
                {{
                  language === "CN"
                    ? scope.row.education_dictText
                    : scope.row.jpeducation_dictText
                }}
              </template>
            </el-table-column>

            <el-table-column
              prop="profession"
              label="専攻"
              width="120"
              :show-overflow-tooltip="true"
            >
              <template slot="header">
                <p>{{ $t("major") }}</p>
                <!-- <el-input
                  v-model="tableSearch5"
                  size="mini"
                  placeholder="Search"
                /> -->
              </template>
            </el-table-column>
            <el-table-column
              prop="japanese"
              label="日本語"
              width="100"
              :show-overflow-tooltip="true"
            >
              <template slot="header">
                <p>{{ $t("japaneseVs") }}</p>
                <!-- <el-input
                  v-model="tableSearch6"
                  size="mini"
                  placeholder="Search"
                /> -->
              </template>
              <template slot-scope="scope">
                <div v-if="language == 'JP'">
                  {{ scope.row.jpjapanese_dictText }}
                </div>
                <div v-else>
                  {{ scope.row.japanese_dictText }}
                </div>
              </template>
            </el-table-column>
          </el-table>

          <!--      分页部分-->
          <div class="pagination-table">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              layout=" prev, pager, next"
              :total="total"
              :page-size="tableSize"
            >
            </el-pagination>
            <!-- Rows per page -->
            <div class="per-page">
              <span>Rows per page</span>
              <div class="rowsPage-css">
                <el-dropdown @command="handleCommand">
                  <span class="el-dropdown-link">
                    {{ tableSize
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="a">7</el-dropdown-item>
                    <el-dropdown-item command="b">15</el-dropdown-item>
                    <el-dropdown-item command="c">20</el-dropdown-item>
                    <el-dropdown-item command="d">25</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- button 部分 -->
      <div class="line-button-box">
        <button class="button-css2" @click="peopleView">
          {{ $t("peopleView") }}
        </button>
        <button class="button-css2" @click="collect">
          {{ $t("collection") }}
        </button>
        <button
          class="button-css2"
          @click="viewEducationCaseClick(educationId)"
        >
          {{ $t("viewJobInformation") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  educationDetailQuery,
  educationalInstitutionDisplay,
  medicalInstitutionDetailsQuery,
  getUrlFromOSS,
  queryEducationPerson,
  allPersonnelQuery,
  collectionInsert
} from "../../js/api";
import AES from "../../js/AES";

export default {
  name: "educationalInstitutionInformation",
  components: {},
  data() {
    return {
      //table数据
      tableData: [],
      educationId: "",
      tableSize: 7,
      currentPage: 1,
      total: 0,
      institutionName: "", //左边機関名
      postCode: "", //左边郵便番号
      area: "", //左边所在地
      agencyAttribute: "", //左边機関属性
      hPorSNS: "", //左边HP or SNS
      representativeName: "", //左边代表者氏名
      phoneNumber: "", //左边機関の電話番号
      numberEmployees: "", //左边授業員数
      studentNumber: "", //左边学生人数
      textData: "", //左边事業内容
      tableSearch1: "", //table学生氏名
      tableSearch2: "", //table性別
      tableSearch3: "", //table生年月日
      tableSearch4: "", //table学歴
      tableSearch5: "", //table専攻
      tableSearch6: "", //table日本語
      address: null,
      language: "",
      schooltableData: [] //学校详情table
    };
  },
  created() {
    //获取当前语言的值
    this.language = window.localStorage.getItem("language");
    console.log("语言选择为" + window.localStorage.getItem("language"));
    console.log("页面语言选择为" + this.language);
    console.log(this.$route.query.educationId);
    this.educationId = this.$route.query.educationId;
    console.log(this.educationId);
    this.getList();
  },
  computed: {},
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
        this.getList();
      }
    },
    //接口 获取表格数据
    getList() {
      //左侧数据获取
      var fakeInfo = {
        educationId: this.$route.query.educationId
      };
      educationDetailQuery(fakeInfo)
        .then(res => {
          console.log("----管理员查询教育机构详细信息接口----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo.data);
            this.total = aesFecInfo.data[0].total;
            this.institutionName = aesFecInfo.data[0].educationName; //機関名
            this.postCode = aesFecInfo.data[0].postNumber; //郵便番号
            this.area = aesFecInfo.data[0].address; //所在地
            this.agencyAttribute = aesFecInfo.data[0].attributes; //機関属性
            this.hPorSNS = aesFecInfo.data[0].hpOrSns; //HP or SNS
            this.representativeName = aesFecInfo.data[0].legalPerson; //代表者氏名
            this.phoneNumber = aesFecInfo.data[0].telephone; //機関の電話番号
            this.numberEmployees = aesFecInfo.data[0].teacherNumber; //授業員数
            this.studentNumber = aesFecInfo.data[0].studentNumber; //学生人数
            this.textData = aesFecInfo.data[0].introduction; //事業内容
            this.getUrlList(aesFecInfo.data[0].avatarAddress);
            this.schooltableData = aesFecInfo.data[0];
          } else {
            this.$message.error("查询失败。");
          }
        })
        .catch(res => {});
      this.getTableList();
    },
    getTableList() {
      //右侧数据获取
      var fakeInfo2 = {
        educationId: this.$route.query.educationId,
        pageNumber: this.currentPage,
        pageSize: this.tableSize,
      };
      allPersonnelQuery(fakeInfo2)
        .then(res2 => {
          console.log("--------教育机构人才信息获取--------");
          console.log(res2);
          if (res2.data.code === "A0000") {
            const aesFecInfo2 = JSON.parse(AES.decrypt(res2.data.data));
            console.log(aesFecInfo2);
            this.tableData = aesFecInfo2.data;
            this.total = aesFecInfo2.total;
          } else {
            this.$message.error("获取学生信息失败。");
          }
        })
        .catch(res => {});
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getTableList();
    },
    //图片回显
    getUrlList(url) {
      console.log("url" + url);
      var fakeInfo = {
        message: url
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          if (res.data.code === "200 OK") {
            console.log("图片回显接口");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo.message);
            this.address = aesFecInfo.message;
          } else {
            console.log(res);
          }
        })
        .catch(() => {});
    },
    //点击教育案件跳转该教育应聘详情
    viewEducationCaseClick() {
      console.log(this.educationId);
      this.$router.push({
        name: "administratorApplicationManagementOnlyEducation",
        query: {
          educationId: this.educationId
        }
      });
    },
    //顾名思义 应聘收藏
    collect() {
      var educationCollectAddDTO = {
        systemEventId: this.educationId,
        systemTypeId: 1
      };
      collectionInsert(educationCollectAddDTO)
        .then(res => {
          console.log("管理员添加应聘案件收藏", res);
          if (res.data.code === "A0000") {
            this.$message({
              message: "收藏成功！",
              type: "success"
            });

            this.$router.push({
              path: "/adminCollectionManagement",
              name: "adminCollectionManagement",
              params: {}
            });
          } else if (res.data.code === "A0506") {
            this.$message({
              message: this.$t("thisApplicationFavorite"),
              type: "warning"
            });
          } else {
            this.$message.error("提交错误！");
          }
        })
        .catch(res => {
          console.log("教育机构添加应聘收藏接口异常", res);
        });
    },
    //人员跳转
    peopleView() {
      this.$router.push({
        path: "/administratorsOnlyEducationStaffManagement",
        name: "administratorsOnlyEducationStaffManagement",
        query: {
          educationId: this.educationId
        }
      });
    },
    //分页条数
    handleCommand(command) {
      if (command === "a") {
        this.tableSize = 7;
      } else if (command === "b") {
        this.tableSize = 15;
      } else if (command === "c") {
        this.tableSize = 20;
      } else if (command === "d") {
        this.tableSize = 25;
      }
      this.currentPage=1
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.main-box {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 0 10px;
  box-sizing: border-box;
}
.main-box-css {
  display: flex;
  height: 620px;
  padding: 30px 0 0 20px;
  background: #fff;
  justify-content: center;
}
.main-box-all-css {
  width: 100%;
  margin: 0 auto;
}
.left-box {
  width: 484px;
  height: 100%;
  background: #fff;
}
.one-line {
  height: 160px;
  display: flex;
}
.avatar {
  width: 150px;
  height: 150px;
  border-radius: 50%;
}
.avatar img {
  width: 150px;
  height: 150px;
}
.institution-name {
  height: 150px;
  flex: 1;
}
.institution-box {
  width: 300px;
  height: 57px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  margin-left: 35px;
  position: relative;
  margin-top: 70px;
  float: left;
}
.institution-title {
  background: #fc630c;
  border-radius: 4px;
  height: 16px;
  width: 49px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 16px;
  letter-spacing: -0.02em;
  color: #ffffff;
  text-align: center;
  position: absolute;
  top: -22px;
  right: 0;
}
.institution-box span {
  position: absolute;
  display: inline-block;
  padding: 0 5px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  top: -12px;
  left: 15px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  background: #ffffff;
}
.institution-main {
  margin-top: 15px;
  padding: 0 20px;
  box-sizing: border-box;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #686868;
}
.two-line {
  height: 50px;
  margin-top: 15px;
  display: flex;
}
.small-input-box {
  width: 200px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.small-input-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}
.small-box-title {
  margin-top: 12px;
  padding-left: 20px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
}
.big-input-box {
  width: 290px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-left: 10px;
}
.big-input-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}
.big-input-box /deep/ .el-input {
  height: 38px;
  border: 1px solid transparent;
  box-sizing: border-box;
}
.big-input-box /deep/ .el-input__inner {
  height: 38px;
  border: 1px solid transparent;
  box-sizing: border-box;
}
.inline-box-dropdown {
  height: 38px;
  width: 180px;
  margin-top: 2px;
  margin-left: 10px;
}
.inline-box-dropdown /deep/ .el-dropdown {
  height: 38px;
  width: 180px;
}
.inline-box-dropdown /deep/ .el-dropdown-link {
  height: 38px;
  line-height: 38px;
  width: 170px;
  position: static;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
}
.inline-box-dropdown /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 38px;
}
.small-dropdown {
  width: 140px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-left: 10px;
}
.small-dropdown span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}
.small-dropdown /deep/ .el-dropdown {
  height: 38px;
  width: 110px;
}
.small-dropdown /deep/ .el-dropdown-link {
  height: 38px;
  line-height: 38px;
  width: 110px;
  position: static;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
}
.small-dropdown /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 38px;
}
.inline-box-dropdown1 {
  height: 38px;
  width: 110px;
  margin-top: 2px;
  margin-left: 10px;
}
.textarea-line {
  margin-top: 15px;
  width: 500px;
  height: 180px;
}
.textarea-line-box {
  width: 484px;
  height: 178px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.textarea-line-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.right-box {
  width: 49%;
  height: 100%;
  margin-left: 50px;
  padding-top: 70px;
  box-sizing: border-box;
}

.right-box /deep/ .el-input__inner {
  border: 1px solid transparent;
  padding: 0;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  text-align: center;
}
.right-box .empty {
  height: 30px;
}
.right-box /deep/ .cell {
  text-align: center;
}
.right-box /deep/ .caret-wrapper {
  position: absolute;
  top: -4px;
  right: 20px;
}
.empty-ps {
  position: relative;
}
.pagination-table {
  display: flex;
  height: 40px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 40px;
  letter-spacing: 0.25px;
  color: #454d59;
  margin-top: 10px;
  align-items: center;
  justify-content: right;
}
.pagination-table /deep/ .el-dropdown {
  background: #ffffff;
  width: 60px;
  line-height: 24px;
  height: 24px;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  margin-left: 10px;
}
.pagination-table /deep/ .el-dropdown-link {
  width: 60px;
  height: 24px;
  padding-left: 10px;
  box-sizing: border-box;
  display: inline-block;
}
.pagination-table /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 24px;
  margin-right: 5px;
}
.pagination {
  margin-top: 10px;
}
.per-page {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}
.main-button-box {
  text-align: center;
  width: 500px;
  margin-top: 20px;
}
.main-button-box button {
  width: 152px;
  height: 40px;
  background: #fc630c;
  border-radius: 4px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}
.textarea-css-main {
  width: 99%;
  height: 99%;
  margin-left: 1px;
  margin-top: 1px;
  border-radius: 8px;
  padding: 15px 5px 5px 20px;
  box-sizing: border-box;
}
.table-img-css {
  border-radius: 50%;
}
.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 25px;
}
.button-css2 {
  width: 150px;
  height: 40px;
  background: #fc630c;
  border-radius: 4px;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/administratorsViewEducationInstitutionsClickDetails/index.vue